<template>
  <a-modal
    title="菜品详情"
    :width="750"
    :maskClosable="false"
    :visible="showModal"
    @cancel="handleCancel"
    :footer="null"
  >
    <a-table :columns="columns" :dataSource="detailData" :pagination="false">
    </a-table>
    <br />
  </a-modal>
</template>

<script>
const columns = [{
  title: '#',
  dataIndex: 'index',
  key: 'index'
}, {
  title: '食材名称',
  dataIndex: 'name',
  key: 'name'
}, {
  title: '编码',
  dataIndex: 'code',
  key: 'code'
}, {
  title: '重量',
  dataIndex: 'weight',
  key: 'weight'
}]

export default {
  data() {
    return {
      columns
    }
  },
  props: {
    showModal: Boolean,
    data: Boolean,
    detailData: {
      type: Array,
      default: () => {
        return []
      }
    },
    totalPrice: {
      type: String,
      default: '0'
    }
  },

  methods: {
    handleCancel() {
      this.$emit('cancel')
    }

  }
}
</script>
<style lang="less" scoped>
</style>
